module.exports = __webpack_public_path__ + "static/media/message-icon.3a19efa2.svg";